module.exports = __webpack_public_path__ + "img/top_title_parts4.20cadf3e.png";